import R from 'ramda';
import utils from './utils';

angular.module('tct.companiesService', ['tct.configService'])
  .factory('companiesService', companiesService);

companiesService.$inject = [
  'configService',
  '$http',
  'mappingService',
];

const businessStatuses = [
  {
    id: 0,
    name: 'BUSINESS_INCOMPLETE',
  },
  {
    id: 1,
    name: 'BUSINESS_TOSEND',
  },
  {
    id: 2,
    name: 'BUSINESS_COMPLETE',
  },
];

const searchOptions = {
  italy: {
    label: 'GENERIC_ITALY',
    radios: [
      {
        label: 'ORDERS_WIZARD_RADIO_NAME',
        value: 'name',
        searchApi: 'searchByName',
        inputs: [
          {
            name: 'name',
            type: 'text',
            label: 'GENERIC_BUSINESSNAME',
            placeholder: 'ORDERS_WIZARD_BUSINESS_NAME_PLACEHOLDER',
            search: 'businessName',
            required: true,
          },
          {
            name: 'province',
            type: 'select',
            label: 'ORDERS_WIZARD_PLACEHOLDER_PROVINCE',
            placeholder: 'GENERIC_SELECT',
            getData: 'getProvinces',
            search: 'province',
            required: false,
          },
          {
            name: 'legal_entity',
            type: 'select',
            label: 'COMPANY_LEGALENTITY',
            placeholder: 'GENERIC_SELECT',
            getData: 'getLegalEntities',
            search: 'legalEntity',
            required: false,
          },
        ],
      },
      {
        label: 'GENERIC_FISCALCODE',
        value: 'fiscal-code',
        searchApi: 'searchByFiscalCode',
        inputs: [
          {
            name: 'fiscal_code',
            type: 'text',
            label: 'COMPANY_FISCALCODE',
            placeholder: 'ORDERS_WIZARD_FISCAL_CODE_PLACEHOLDER',
            search: 'fiscalCode',
            required: true,
          },
          {
            name: 'province',
            type: 'select',
            label: 'ORDERS_WIZARD_PLACEHOLDER_PROVINCE',
            placeholder: 'GENERIC_SELECT',
            getData: 'getProvinces',
            search: 'province',
            required: false,
          },
        ],
      },
      {
        label: 'COMPANY_REA',
        value: 'rea',
        searchApi: 'searchByRea',
        inputs: [
          {
            name: 'rea-number',
            type: 'text',
            label: 'COMPANY_REA',
            placeholder: 'ORDERS_WIZARD_REA_NUMBER_PLACEHOLDER',
            search: 'reaNumber',
            required: true,
          },
          {
            name: 'cciaa',
            type: 'select',
            label: 'ORDERS_WIZARD_PLACEHOLDER_PROVINCE',
            placeholder: 'GENERIC_SELECT',
            getData: 'getProvinces',
            search: 'cciaaNumber',
            required: false,
          },
        ],
      },
      {
        label: 'COMPANY_VAT',
        value: 'vat',
        searchApi: 'searchByVatNumber',
        inputs: [
          {
            name: 'vat-number',
            type: 'text',
            label: 'COMPANY_VAT',
            placeholder: 'ORDERS_WIZARD_VAT_NUMBER_PLACEHOLDER',
            search: 'vatNumber',
            required: true,
          },
          {
            name: 'cciaa',
            type: 'select',
            label: 'ORDERS_WIZARD_PLACEHOLDER_PROVINCE',
            placeholder: 'GENERIC_SELECT',
            getData: 'getProvinces',
            search: 'cciaaNumber',
            required: false,
          },
        ],
      },
    ],
  },
  foreign: {
    label: 'GENERIC_FOREIGN',
    radios: [
      {
        value: 'foreign',
        searchApi: 'searchForeignByName',
        inputs: [
          {
            name: 'name',
            type: 'text',
            label: 'ORDERS_WIZARD_RADIO_NAME',
            placeholder: 'ORDERS_WIZARD_BUSINESS_NAME_PLACEHOLDER',
            search: 'businessName',
            required: false,
          },
          {
            name: 'registrationNumber',
            type: 'text',
            label: 'REGISTRATION_NUMBER_OR_DUNS',
            placeholder: 'GENERIC_PLACEHOLDER_INSERTHERE',
            search: 'registrationNumber',
            required: false,
          },
          {
            name: 'country',
            type: 'select',
            label: 'GENERIC_COUNTRY',
            placeholder: 'GENERIC_SELECT',
            getData: 'getForeignCountries',
            search: 'country',
            required: true,
          },
        ],
      },
    ],
  },
};

function companiesService(config, $http, mappingService) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/companies`;
  const baseSearchPath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/search`;
  const factory = {
    getCompany,
    getCompanies,
    getCompaniesSelect,
    getCompanyBusinessInfo,
    businessStatuses,
    getCompanyStructure,
    getTechDoc,
    getTechDocList,
    updateTechDoc,
    saveTechDoc,
    createTechDoc,
    setTechDocToDraft,
    getAllCountries,
    getForeignCountries,
    createCompany,
    searchByFiscalCode,
    searchByVatNumber,
    searchByName,
    searchByRea,
    searchForeignByName,
    getSearchOptions,
    getProvinces,
    getLegalEntities,
    removeTechDoc,
    getBaseAccountsForCompany,
    getCompanyQuestionnaireList,
    getCompanyContracts,
    updateCompanyContract,
    createContract,
    getCompanyBudgets,
    createCompanyBudget,
    updateCompanyBudget,
    editCompany,
  };

  return factory;

  function getCompany(id) {
    return $http.get(`${basePath}/${id}`);
  }
  function getCompaniesSelect(param) {
    const url = `${basePath}`;
    const params = {
      select: true,
    };

    if (param.name) {
      params['filters[name]'] = param.name;
    }

    if (param.foreign) {
      params['filters[foreign]'] = 1;
    }

    if (typeof param.clients !== 'undefined') {
      params['filters[type]'] = param.clients
        ? 'client'
        : 'noclient';
    }

    return $http.get(url, { params });
  }
  function getCompanies(param) {
    const url = `${basePath}`;
    const params = {};
    params['filters[name]'] = param.search.name;
    params['filters[type]'] = param.search.type;
    params['filters[vat_number]'] = param.search.vatNumber;
    params.limit = param.limit;
    params.page = param.page;
    const sort = R.filter(pair => !R.isNil(pair[1]) && !R.isEmpty(pair[1]), R.toPairs(param.sort));
    if (sort.length > 0) {
      params.sort_by = sort[0][0];
      params.sort_dir = sort[0][1];
    }

    return $http.get(
      url,
      {
        params,
      },
    );
  }
  function getCompanyBusinessInfo(companyId, params) {
    const url = `${basePath}/${companyId}/documents/bi`;
    const formattedParams = {
      limit: params.limit || 10,
      page: params.page || 1,
    };
    const searchParamsObj = R.reduce(utils.withQueryParams, {}, R.toPairs(params.search));
    const sortPairs = R.filter(
      obj => !R.isNil(obj[1]) && !R.isEmpty(obj[1]),
      R.toPairs(params.sort || {}));

    const sortParamsObj = sortPairs.length > 0
      ? { sort_by: sortPairs[0][0], sort_dir: sortPairs[0][1] }
      : {};

    const completeParamObj = Object.assign({}, formattedParams, searchParamsObj, sortParamsObj);
    return $http.get(url, { params: completeParamObj });
  }

  function getCompanyStructure(companyId) {
    const url = `${basePath}/${companyId}/accounts`;
    return $http.get(url);
  }

  function getTechDocList(companyId) {
    const url = `${basePath}/${companyId}/technical-informations`;
    return $http.get(url);
  }

  function getTechDoc(companyId, techDocId) {
    const url = `${basePath}/${companyId}/technical-informations/${techDocId}`;
    return $http.get(url);
  }

  function updateTechDoc(companyId, techDocId, content) {
    const url = `${basePath}/${companyId}/technical-informations/${techDocId}`;
    return $http.put(url, { content });
  }

  function setTechDocToDraft(companyId, techDocId) {
    const url = `${basePath}/${companyId}/technical-informations/${techDocId}/status`;
    return $http.put(url, { status: 'requested' });
  }

  function saveTechDoc(companyId, techDocId, content) {
    const url = `${basePath}/${companyId}/technical-informations/${techDocId}/available`;
    return $http.put(url, { content });
  }

  function createTechDoc(companyId, data) {
    const url = `${basePath}/${companyId}/technical-informations`;
    return $http.post(url, data);
  }

  function getAllCountries(param) {
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/countries`;
    return $http.get(url, { params: { q: param.name } });
  }

  function getForeignCountries(param) {
    param.exclude = '';
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/countries`;
    return $http.get(url, { params: { q: param.name, exclude: param.exclude } });
  }

  function createCompany(data) {
    const url = `${basePath}`;
    const agency = {
      name: data.name,
      country_id: data.countryId,
      fiscal_code: data.fiscalcode,
      vat_number: data.vatnumber,
      rea_number: data.countryId === 'IT' ?
        data.rea :
        null,
      cciaa: data.countryId === 'IT' ?
        data.cciaa :
        null,
      duns: data.countryId !== 'IT' ?
        data.duns :
        null,
      registration_number: data.countryId !== 'IT' ?
        data.registrationNumber :
        null,
      client_code: data.clientcode,
    };

    return $http.post(url, agency);
  }

  function getProvinces() {
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/provinces`;
    return $http.get(url);
  }

  function getLegalEntities() {
    const url = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/legal-entities`;
    return $http.get(url);
  }

  function searchByFiscalCode(params) {
    const url = `${baseSearchPath}/it/fiscal-code`;
    return $http
      .get(url, {
        params: {
          fiscal_code: params.fiscalCode,
          cciaa: params.province ? params.province : undefined,
          privacy_accepted: params.privacyAccepted ? 1 : 0,
        },
      });
  }

  function searchByVatNumber(params) {
    const url = `${baseSearchPath}/it/vat`;
    return $http.get(url, {
      params: {
        vat_number: params.vatNumber,
        cciaa: params.cciaaNumber,
        privacy_accepted: params.privacyAccepted ? 1 : 0,
      },
    });
  }

  function searchByName(params) {
    const url = `${baseSearchPath}/it/name`;
    return $http.get(url, {
      params: {
        name: params.businessName,
        cciaa: params.province ? params.province : undefined,
        legal_entity: params.legalEntity ? params.legalEntity : undefined,
        privacy_accepted: params.privacyAccepted ? 1 : 0,
      },
    });
  }

  function searchByRea(params) {
    const url = `${baseSearchPath}/it/rea`;
    return $http.get(url, {
      params: {
        rea_number: params.reaNumber,
        cciaa: params.cciaaNumber,
        privacy_accepted: params.privacyAccepted ? 1 : 0,
      },
    });
  }

  function searchForeignByName(params) {
    const url = `${baseSearchPath}/foreign/name`;
    return $http.get(url, {
      params: {
        name: params.businessName,
        registration_number: params.registrationNumber,
        country: params.country,
        privacy_accepted: params.privacyAccepted ? 1 : 0,
      },
    });
  }

  function getSearchOptions() {
    return searchOptions;
  }

  function removeTechDoc(companyId, techDocId) {
    const url = `${basePath}/${companyId}/technical-informations/${techDocId}`;
    return $http.delete(url);
  }

  function getBaseAccountsForCompany(parameters) {
    const url = `${basePath}/${parameters.companyId}/accounts/base`;
    return $http
      .get(url)
      .then(response => mappingService.objectKeysToCamel(response));
  }

  function getCompanyQuestionnaireList(companyId) {
    const url = `${basePath}/${companyId}/questionnaires`;
    return $http.get(url);
  }

  function getCompanyContracts(companyId) {
    const url = `${basePath}/${companyId}/contracts`;
    return $http.get(url);
  }

  function updateCompanyContract(companyId, contractId, contract) {
    const url = `${basePath}/${companyId}/contracts/${contractId}`;
    return $http.put(url, contract);
  }

  function createContract(companyId, contract) {
    const url = `${basePath}/${companyId}/contracts`;
    return $http.post(url, contract);
  }

  function getCompanyBudgets(companyId) {
    const url = `${basePath}/${companyId}/budgets`;
    return $http.get(url);
  }

  function createCompanyBudget(companyId, ownerId, parentBudgetId) {
    const url = `${basePath}/${companyId}/budgets`;
    const data = {
      ownerId,
    };
    if (parentBudgetId) {
      data.parentBudgetId = parentBudgetId;
    }
    return $http.post(url, mappingService.objectKeysToSnake(data));
  }

  function updateCompanyBudget(companyId, budgetId, credits) {
    const url = `${basePath}/${companyId}/budgets/${budgetId}`;
    const data = { credits };

    return $http.put(url, mappingService.objectKeysToSnake(data));
  }

  function editCompany(id, company) {
    const url = `${basePath}/${id}`;
    return $http.put(url, mappingService.objectKeysToSnake(company));
  }
}
